module.exports = __webpack_public_path__ + "static/five-logo-5ab214dc6d8c90e00628a15f63f15290.png";